export default __webpack_public_path__ + "static/media/Aftab2.aa5b48f5.jpg";